import { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { Helmet } from "react-helmet-async";
import { FAQ_ITEMS } from "@/lib/content";

export default function FAQ({ items }) {
    const data = items || FAQ_ITEMS;
    const [open, setOpen] = useState(0);

    return (
        <div data-testid="faq-list" className="border-t border-champagne/30">
            <Helmet>
                <script type="application/ld+json">{JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "FAQPage",
                    "mainEntity": data.map((q) => ({
                        "@type": "Question",
                        "name": q.q,
                        "acceptedAnswer": { "@type": "Answer", "text": q.a },
                    })),
                })}</script>
            </Helmet>
            {data.map((item, i) => (
                <div key={i} data-testid={`faq-item-${i}`} className="border-b border-champagne/30">
                    <button
                        onClick={() => setOpen(open === i ? -1 : i)}
                        className="w-full flex items-center justify-between py-6 text-left group"
                        data-testid={`faq-toggle-${i}`}
                    >
                        <span className="font-serif text-xl md:text-2xl pr-6 group-hover:text-champagne transition-colors">{item.q}</span>
                        <span className="shrink-0 text-champagne">
                            {open === i ? <Minus strokeWidth={1.2} /> : <Plus strokeWidth={1.2} />}
                        </span>
                    </button>
                    <div
                        className={`grid transition-all duration-500 ease-in-out ${
                            open === i ? "grid-rows-[1fr] opacity-100 pb-6" : "grid-rows-[0fr] opacity-0"
                        }`}
                    >
                        <div className="overflow-hidden">
                            <p className="text-ink/70 leading-relaxed max-w-2xl">{item.a}</p>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}
